/**
 * Marks for the external site resources: the customer portal's Site
 * Resources panel and location Resources card, and the admin location
 * page's Site resources card. One entry per `directoryLinks()` key.
 *
 * `icon` is a square PNG every app that renders a mark ships under its own
 * `public/resources/` (customer-portal and admin today). PazNetworks-run surfaces
 * (Mission Control, Rankings, PazNet Learn) carry the PazNet mark; vendor
 * consoles carry the vendor's own mark (owner-supplied 2026-09-21). Keys
 * without an icon fall back to the two-letter `abbr` so a resource never
 * renders a broken image.
 */
export type ResourceMarkKey =
  | 'missionControl'
  | 'auvik'
  | 'unifi'
  | 'communicationsVendor'
  | 'rankings'
  | 'ordering'
  | 'learn'
  | 'engineering';

export interface ResourceMarkSpec {
  /** Two-letter fallback shown when there is no icon or it fails to load. */
  abbr: string;
  /** Square PNG under the app's /public/resources, if the resource has a mark. */
  icon?: string;
}

export const PAZNET_MARK = '/resources/paznet-mark.png';

export const RESOURCE_MARKS: Record<ResourceMarkKey, ResourceMarkSpec> = {
  missionControl: { abbr: 'MC', icon: '/resources/paznet-mission-control.png' },
  auvik: { abbr: 'AV', icon: '/resources/auvik.png' },
  unifi: { abbr: 'UI', icon: '/resources/unifi.png' },
  communicationsVendor: { abbr: 'PC' },
  rankings: { abbr: 'RK', icon: PAZNET_MARK },
  ordering: { abbr: 'WQ' },
  learn: { abbr: 'PL', icon: PAZNET_MARK },
  engineering: { abbr: 'EF' },
};
